<template>
  <div class="navbar-menu ">
    <el-menu collapse mode="horizontal" menu-trigger="hover">
      <el-submenu index="1" popper-class="navbar-menu-popper">
        <template slot="title">
          <svg-icon icon-class="top_menu" style="font-size: 20px;margin-left: 0" />
        </template>
        <el-submenu v-if="!isSalesForSzFs" index="1-1" popper-append-to-body popper-class="navbar-menu-popper">
          <template slot="title">
            {{ $t('Menu.HelpCenter') }}
          </template>
          <el-menu-item @click="showOperationGuide">{{ $t('Menu.SystemOperationGuidance') }}</el-menu-item>
          <el-menu-item @click="showInitGuide">{{ $t('Menu.InitializeBoot') }}</el-menu-item>
        </el-submenu>
        <el-menu-item @click="refreshCache">{{ $t('CargoMsg.Cargo_Reflush') }}</el-menu-item>
        <el-menu-item @click="showSettingAndTools">
          {{ $t('Menu.SettingsAndTools') }}
        </el-menu-item>
        <el-menu-item v-if="sysPopUpMenuList.indexOf('tweet') > -1 && !isSalesForSzFs">
          <a href="http://e.weibo.com/walltechsystem/profile/" target="_blank">{{ $t('Menu.Weibo') }}</a>
        </el-menu-item>
        <el-menu-item v-if="!isSalesForSzFs" @click="logInfoDrawerVisible = true">
          {{ $t('Menu.LogInformation') }}
        </el-menu-item>
        <el-menu-item v-if="!isSalesForSzFs" @click="unBindWeChat">
          {{ $t('Menu.UnbindWeChat') }}
        </el-menu-item>
        <el-menu-item v-if="sysPopUpMenuList.indexOf('sysInfo') > -1 && !isSalesForSzFs" @click="sysInfoDialogVisible = true">
          {{ $t('Menu.SystemInformation') }}
        </el-menu-item>
        <el-menu-item @click="logout">
          {{ $t('Menu.SignOut') }}
        </el-menu-item>
      </el-submenu>
    </el-menu>
    <init-guide-dialog :visible.sync="initGuideVisible" />
    <setting-and-tools :visible.sync="innerSettingAndToolsVisible" />
    <log-info-drawer :visible.sync="logInfoDrawerVisible" />
    <el-dialog
      :title="$t('Menu.SystemInformation')"
      :visible="sysInfoDialogVisible"
      width="500px"
      append-to-body
      @close="sysInfoDialogVisible=false"
    >

      <div style="text-align: center">
        <div style="height: 181px;text-align: center;">
          <img :src="sysInfoLogo" style="height: 120px;margin-top: 40px">
        </div>
        <!--        <p>Build:{{ $store.getters.version }}</p>-->
        <p>Build:25.01.13.125</p>
        <p>{{ copyright }}</p>
        <el-link type="primary" href="http://www.walltechsystem.cn" target="_blank">http://www.walltechsystem.cn</el-link>
      </div>
    </el-dialog>
    <iframe id="qq-frame" name="qq-frame" style="display: none" :src="qqUrl" />
  </div>
</template>
<script>
import { getLoading } from '@/utils/utilBaseElement'
import { refreshBasicData } from '@/utils/basicDataCache'
import { cache, cacheName } from '@/utils/cacheManager'
import InitGuideDialog from './components/initGuideDialog'

import Driver from 'driver.js' // import driver.js
import 'driver.js/dist/driver.min.css'
import SettingAndTools from './components/SettingAndTools'
import logInfoDrawer from './components/logInfoDrawer'

import { queryWechatUser, wechatUntied } from '@/api/auth'
import logo5 from '@/assets/logo/logo5.png'

export default {
  name: 'NavbarMenu',
  components: { SettingAndTools, InitGuideDialog, logInfoDrawer },
  data() {
    return {
      consoleURL: '',
      user: null,
      initGuideVisible: false,
      innerSettingAndToolsVisible: this.$store.state.settings.settingAndToolsVisible,
      sysInfoDialogVisible: false,
      logInfoDrawerVisible: false,
      qqUrl: '',
      sysPopUpMenuList: []
    }
  },
  computed: {
    copyright() {
      return `Copyright ${new Date().getFullYear()}  Wall Tech Limited.All rights reserved.`
    },
    is100() {
      return this.$store.getters.tenantId === 100
    },
    sysInfoLogo() {
      return logo5
    },
    isSalesForSzFs() { // 深圳丰收销售专用
      return String(cache.config.get('ToExoSystem')) === 'SZFS' && !this.$store.getters.isAdmin &&
        (this.$checkPermission(['role_salesOfGoods']) || this.$checkPermission(['role_RemoteBooking_queryPrivateCustom']) ||
          this.$checkPermission(['role_platform_sales']) || this.$checkPermission(['role_branchSales']) || this.$checkPermission(['role_sales']))
    }
  },
  watch: {
    '$store.state.settings.settingAndToolsVisible': {
      handler(newval) {
        this.innerSettingAndToolsVisible = newval
      }
    },
    innerSettingAndToolsVisible(newVal) {
      this.$store.dispatch('settings/changeSetting', { key: 'settingAndToolsVisible', value: newVal })
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async unBindWeChat() {
      try {
        const res = await queryWechatUser().catch(() => { throw new Error(this.$t('Menu.WeChatUnbindingFailed')) })
        if (res.data) {
          await this.$confirm(this.$t('Menu.WhetherToConfirmWeChatUnbinding'), this.$t('CargoMsg.Cargo_ConfirmR'), { type: 'warning' }).catch(() => { throw new Error(this.$t('Menu.Unbind')) })
          await wechatUntied().then(res => {
            if (res.data) {
              this.$message.success(this.$t('Menu.WeChatUnbindingSuccessfully'))
            } else {
              throw new Error(this.$t('Menu.WeChatUnbindingFailed'))
            }
          })
        } else {
          this.$message.warning(this.$t('Menu.DearYouHaventBoundYourWeChatAccountYet'))
        }
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    logout() {
      this.$store.dispatch('tagsView/delAllViews').then(() => {
        return this.$store.dispatch('user/logout')
      }).then(() => {
        // location.reload()// In order to re-instantiate the vue-router object to avoid bugs
        this.$router.push('/login')
      }).catch(() => {
        location.reload()
      })
    },
    async initData() {
      await cache.load(cacheName.CONFIG)
      this.user = this.$store.getters.userInfo
      const sysPopUpMenuList = String(cache.config.get('SysPopUpMenuList'))
      const array = sysPopUpMenuList.split(',')
      if (array && array.length > 0) {
        for (const item of array) {
          if (item) {
            this.sysPopUpMenuList.push(item)
          }
        }
      }
    },
    refreshCache() {
      console.log('更新')
      this.$message.success(this.$t('Message.StartUpdatingTheBasicData'))
      this.loading = getLoading()
      refreshBasicData().then(() => {
        this.loading.close()
        this.$message.success(this.$t('Message.BasicDataUpdateSuccessfully'))
      }).catch(() => {
        this.loading.close()
      })
    },
    showOperationGuide() {
      console.log('操作引导')
      const driver = new Driver({
        doneBtnText: this.$t('Menu.Finish'), // Text on the final button
        closeBtnText: this.$t('Menu.Skip'), // Text on the close button for this step
        nextBtnText: this.$t('Menu.Next'), // Next button text for this step
        prevBtnText: this.$t('Menu.Back')
      })
      const steps = [
        {
          element: '#account-info',
          popover: {
            title: this.$t('Menu.AccountInformation'),
            description: this.$t('Menu.ShowYourAccountNumberAndTheCompaniesAndDepartmentsToWhichYouBelongHere'),
            position: 'bottom'
          }
        }, {
          element: '#message-reminder',
          popover: {
            title: this.$t('Menu.InStationMessageReminder'),
            description: this.$t('Menu.WhenYouHaveAPendingTaskThereWillBeAToDoNumberOnTheBellToRemindYouToDealWithItInTime'),
            position: 'left'
          }
        }, {
          element: '#walltech-home',
          popover: {
            title: this.$t('Menu.WallTechFamily'),
            description: this.$t('Menu.ClickHereToEnterWallTechFamilyToViewYourOrderTrainingVideosAndOtherInformation'),
            position: 'left'
          }
        }, {
          element: '#online-service',
          popover: {
            title: this.$t('Menu.OnlineCustomerService'),
            description: this.$t('Menu.WhenYouEncounterProblemsWithYourOperatingSystemYouCanContactOurOnlineCustomerServiceAtAnyTime'),
            position: 'left'
          }
        }, {
          element: '#lang-select',
          popover: {
            title: this.$t('Menu.MultilingualSwitching'),
            description: this.$t('Menu.SwitchDifferentLanguages'),
            position: 'left'
          }
        }, {
          element: '#navbar-menu',
          popover: {
            title: this.$t('Menu.More'),
            description: this.$t('Menu.HereIsAHelpfulCenterSystemRelatedConfigurationToolsReportStatisticsBillingSystemAndOtherMoreInformation'),
            position: 'left'
          }}, {
          element: '#app-main',
          popover: {
            title: this.$t('Menu.OperationArea'),
            description: this.$t('Menu.HereIsTheOperationInterfaceForYourDailyWork'),
            position: 'mid-center'
          }}, {
          element: '#sidebar-container',
          popover: {
            title: this.$t('Menu.MenuBar'),
            description: this.$t('Menu.TheSystemModuleMenuBarDisplayedHereMatchesThePermissionsOfYourLoginAccount'),
            position: 'right'
          }}
      ]
      driver.defineSteps(steps)
      driver.start()
    },
    showInitGuide() {
      console.log('初始化引导')
      this.initGuideVisible = true
    },
    showSettingAndTools() {
      console.log('设置与工具')
      this.innerSettingAndToolsVisible = true
    },
    openQq() {
      console.log('备用qq')
      const iframe = document.getElementById('qq-frame')
      if (!this.qqUrl) {
        this.qqUrl = 'http://wpa.b.qq.com/cgi/wpa.php?ln=2&uin=4006659211'
      } else {
        window.open(iframe.src, 'qq-frame', '')
      }
    },
    goStatistics() {
      console.log('报表统计')
      const reportUrl = cache.config.get('ReportURL')
      if (reportUrl == null || reportUrl.length === 0) {
        this.$message.warning(this.$t('Menu.YouAreNotAuthorizedToUseStatisticalAnalysisFunction'))
        return
      }
      const { userId, sessionId, username, uuid } = this.user
      const fsuserid = userId
      const officeId = this.$store.getters.currentOfficeId
      const fsusername = username
      const user_uuid = uuid
      const url = `${reportUrl}?op=cargo_load&cmd=login&fsuserid=${fsuserid}&officeId=${officeId}&sessionId=${sessionId}&fsusername=${fsusername}&user_uuid=${user_uuid}`
      this.openInNewWindow(url)
    },
    goBs() {
      console.log('计费系统')
      const bsServerURL = cache.config.get('bsServerURL')
      if (bsServerURL) {
        this.openInNewWindow(`${bsServerURL}?sessionId=${this.user.sessionId}`)
      } else {
        const env = this.$store.getters.env === 'dev' ? 'stage' : this.$store.getters.env
        const serverUrl = env === 'prod' ? `http://cargoware.hi-strong.com` : `http://${env}.cargoware.com`
        const { sessionId } = this.user
        const url = `${serverUrl}/ForwardServlet?sessionId=${sessionId}&target=BS`
        this.openInNewWindow(url)
      }
    },
    openInNewWindow(url) {
      const el = document.createElement('a')
      document.body.appendChild(el)
      el.href = url
      el.target = '_blank'
      el.click()
      document.body.removeChild(el)
    }
  }
}
</script>
<style lang="scss">
.navbar-menu {
  .el-menu--horizontal{
    width: auto;
    border:none!important;
  }
  .el-submenu__title{
    height: 28px!important;
    line-height: 28px!important;
    border-bottom: none!important;
  }
}
.navbar-menu-popper{
  .el-menu-item{
    a {
      font-size: 14px;
      display: block;
    }
  }
}
</style>
